import {HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {pipe} from 'rxjs';
import {ApiService} from 'src/app/core/services/api.service';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ShortLinkService {

  constructor(private apiService: ApiService) {
  }

  getFullLink(shortLink) {
    const body = {shortLink: shortLink}
    return this.apiService.post('/anonymous/full-url-sign', body).pipe(map(res => {
      return res;
    }));
  }

  getFullLinkAnonymous(shortLink) {
    const body = {shortLink: shortLink}
    return this.apiService.post('/contract/full-url-sign-anonymous', body).pipe(map(res => {
      return res;
    }));
  }


}
